<script>
/**
* @描述
* 发送验证码组件的封装
* @使用方法
  <g-send-code
    :disabled.sync="codeDiabled"
    :phone="form.Phone"
  ></g-send-code>
* @param
* codeDiabled: 发送验证码按钮是否可点击。 这块使用的sync语法糖进行双向数据绑定
* phone: 传递过来的phone手机号
* count: 持续多少秒时间
* @LastEditTime: 最后更新时间
* 2021-08-31
*/
</script>
<template>
  <div>
    <van-button
      type="info"
      round
      size="mini"
      :color="color"
      :disabled="disabled"
      @click.stop.prevent="getCode"
      >{{ txt }}</van-button
    >
  </div>
</template>

<script>
export default {
  name: "GSendCode",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    phone: {
      type: [String, Number],
      default: "",
    },
    count: {
      type: Number,
      default: 60,
    },
    color: {
      type: String,
      default: "",
    },
    click: {
      type: [String, Function],
      default: "",
    },
  },
  watch: {
    // disabled(val) {
    //   this.sDiabled = val;
    // }
  },
  data() {
    return {
      sDiabled: "",
      timer: "",
      txt: "获取验证码",
      sCount: this.count,
    };
  },
  components: {},
  created() {
    // this.sDiabled = this.disabled;
  },
  mounted() {},
  methods: {
    getCode() {
      let isValid = $pub.isValidPhone(this.phone);
      if (!isValid) {
        return this.$toast("请输入正确的手机号");
      }
      if (typeof this.click === "function") {
        this.click();
      } else {
        $http("wechath5/zh-cn/v1/member/getbindsmscode", {
          Phone: this.phone,
        }).then((res) => {
          this.$toast("发送验证码成功");
          this.activeCode();
        });
      }
    },
    activeCode() {
      this.$emit("update:disabled", true);
      this.innerFunc();
      this.timer = setInterval(() => {
        this.innerFunc();
      }, 1000);
    },
    innerFunc() {
      this.sCount--;
      this.txt = this.sCount;
      if (this.sCount === 0) {
        this.reset();
      }
    },
    reset() {
      this.$emit("update:disabled", false);
      this.sCount = this.count;
      this.txt = "获取验证码";
      clearInterval(this.timer);
    },
  },
};
</script>
<style scoped lang="scss"></style>
